export const appTermsLinkPath = 'https://the-matsuu-studio.notion.site/889bc4c5285e43ed8678052cfa67c0d3?pvs=74'
export const appServiceLinkPath = (accountName: string, conversationId?: string) =>
  `https://docs.google.com/forms/d/e/1FAIpQLScpq7QQLCG3LQSmhVDx3HFXbIEzw0MlfcdRibGI7wBfy_Gapw/viewform?usp=pp_url&entry.688530819=${accountName}&entry.1357083427=${conversationId}`
export const appPrivacyPolicyLinkPath = 'https://housol.co.jp/posts/j47pHHC9'
export const appCompanyLinkPath = 'https://housol.co.jp/'
